import { ReactGrid, Cell } from '@silevis/reactgrid';
import { Box, Typography } from '@mui/material';
import usePlanStore from '../../../../../../../../../../store/planStore';
import useAddWeeksRow from './hooks/useAddWeeksRow';
import { Dataset } from './interfaces';
import useAddMonthsRow from './hooks/useAddMonthsRow';
import useAddNumberOfDaysRow from './hooks/useAddNumberOfDaysRow';
import useAddCopyDataRows from './hooks/useAddCopyDataRows';
import useAddTotalsRow from './hooks/useAddTotalsRow';
import useAddGrandTotal from './hooks/useAddGrandTotal';

export default function GrpSettingsTable() {
  const { countryForms, selectedCountry } = usePlanStore();

  const dataset: Dataset | undefined =
    countryForms[selectedCountry!]?.offline?.tv;

  const weeks = dataset?.grpTable?.weeks ?? [];
  const cells: Cell[] = [];

  const rows = [
    {
      rowIndex: 0,
      height: '45px',
    },
    {
      rowIndex: 1,
      height: '45px',
    },
    {
      rowIndex: weeks.length + 2,
      height: '45px',
    },
  ];

  const columns = [
    {
      colIndex: 0,
      width: 100,
      minWidth: 100,
    },
    {
      colIndex: 1,
      width: 100,
      minWidth: 100,
    },
    {
      colIndex: (weeks.length ?? 0) + 2,
      width: 100,
      minWidth: 100,
    },
  ];

  weeks.forEach((week, index) => {
    columns.push({
      colIndex: index + 2,
      width: 100,
      minWidth: 100,
    });
  });

  weeks.forEach((week, index) => {
    rows.push({
      rowIndex: index + 2,
      height: '45px',
    });
  });

  useAddMonthsRow(cells, weeks);
  useAddWeeksRow(cells);
  useAddNumberOfDaysRow(cells, weeks);
  useAddCopyDataRows(cells);
  useAddTotalsRow(cells);
  useAddGrandTotal(cells);

  return (
    <Box sx={{ minWidth: '100%', width: '600px', overflow: 'auto' }}>
      {dataset?.grpTable && (
        <ReactGrid cells={cells} rows={rows} columns={columns} />
      )}
    </Box>
  );
}
